<template>
    <a-row type="flex" :gutter="16">
        <a-col :span="4">
            <template>
                <div style="text-align: center">
                    <a-avatar :src="userInfo.photo" shape="square" :size="100" icon="user" />
                </div>
            </template>
        </a-col>
        <a-col :span="20">
            <a-skeleton :loading="loading" active>
                <a-descriptions bordered>
                    <a-descriptions-item label="Nama">
                        <strong>{{ userInfo.name }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Gender">
                        <strong>{{ gender }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Email">
                        <strong>{{ userInfo.email }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Jabatan">
                        <strong>{{ userInfo.position }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Cabang">
                        <div v-if="userInfo.members != null">
                            <strong>{{ branch }}</strong>
                        </div>
                    </a-descriptions-item>

                    <a-descriptions-item label="Penilai" v-if="penilai > 0">
                        <strong>{{ penilai }}</strong>
                    </a-descriptions-item>
                </a-descriptions>
            </a-skeleton>
        </a-col>
    </a-row>
</template>

<script>
export default {
    props: {
        user_hash: {
            type: String,
            required: false,
            default: null
        },
        penilai: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            userInfo: {}
        }
    },
    created() {
        this.getInfo()
    },
    computed: {
        gender() {
            return this.userInfo.gender === 'female' ? 'Perempuan' : this.userInfo.gender === 'male' ? 'Laki-laki' : ''
        },
        branch() {
            return _.isObject(this.userInfo.members[0].branch) ? this.userInfo.members[0].branch.name : ''
        },
        position() {
            return _.isObject(this.userInfo.members[0].position) ? this.userInfo.members[0].position.name : ''
        }
    },
    methods: {
        getInfo(){
            if (this.user_hash !== null) {
                this.loading = true

                this.$http
                    .post(this.routeUri('api.general.user.info', { user_hash: this.user_hash}))
                    .then(response => (this.userInfo = response.data))
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false))
            } else {
                this.userInfo = this.$laravel.user
            }
        }
    }
};
</script>
